import {merge} from 'lodash';

/**
 * merge different config
 * @returns {Promise<*>}
 */
const convertConfig = async () => {
	let config;

	if (process.env.REACT_APP_CI_ENV === 'true') {
		config = await import('../config.app.cd.json').then((c) => c.default);
	} else if (process.env.NODE_ENV === 'development') {
		config = await import('../config.app.dev.json').then((c) => c.default);
	} else {
		config = await import('../config.app.json').then((c) => c.default);
		config = merge({}, config, {
			LOC_SERVER: window.LOC_SERVER || '',
			WATCH_SITE_PREFIX: window.WATCH_SITE_PREFIX || window.LOC_SERVER || '',
			CONFIG_URL: `${window.SPA_PREFIX || config.SPA_PREFIX}${config.CONFIG_URL}`,
			I18N_URL: `${window.SPA_PREFIX || config.SPA_PREFIX}${config.I18N_URL}`,
		});
	}

	if (window.NLENV) {
		config.app = config.app || {};
		config.app.env = window.NLENV;
	}

	return merge({}, config);
};

export {convertConfig};
